import React from 'react';
import { FaBox } from 'react-icons/fa';
import { mapKeyToField, SUBMASTER_TYPES } from './utils';

const BuyerLedgerLedgerConfiguration = ({ form, errors, options, companyBranches, onChange }) => (
  <div className="card border-0 shadow-sm mb-4 blc-card blc-card-blue">
    <div className="card-header bg-white border-0 pb-0">
      <h5 className="mb-0 blc-card-title blc-card-title-blue">
        <FaBox className="me-2" />
        Ledger Configuration
      </h5>
    </div>
    <div className="card-body">
      <div className="row">
        <div className="col-lg-12 mb-3">
          <label className="form-label fw-semibold text-dark">
            Company / Branch <span className="text-danger">*</span>
          </label>
          <select
            name="clientTo"
            value={form.clientTo}
            onChange={onChange}
            className={`form-select form-select-lg blc-input ${errors.clientTo ? 'is-invalid' : ''}`}
          >
            <option value="">Select Company / Branch</option>
            {companyBranches.map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.label} ({branch.companyName})
              </option>
            ))}
          </select>
          {errors.clientTo && <div className="invalid-feedback d-block">{errors.clientTo}</div>}
        </div>
      </div>
      <div className="row">
        {SUBMASTER_TYPES.map((t) => {
          const field = mapKeyToField(t.key);
          return (
            <div className="col-lg-4 mb-3" key={t.key}>
              <label className="form-label fw-semibold text-dark">
                {t.label} <span className="text-danger">*</span>
              </label>
              <select
                name={field}
                value={form[field]}
                onChange={onChange}
                className={`form-select form-select-lg blc-input ${errors[field] ? 'is-invalid' : ''}`}
              >
                <option value="">Select {t.label}</option>
                {(options[t.key] || []).map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
              {errors[field] && <div className="invalid-feedback d-block">{errors[field]}</div>}
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default BuyerLedgerLedgerConfiguration;
